@if (showWatermark) {
  <div class="watermark">360interview.ai</div>
}

@if (isConfig) {
  <div class="body vertical-large config">
    <div class="page-header">
      <div class="page-title">Setup Audio Options to launch AI Assistant</div>
    </div>

    <div class="steps">
      <nz-steps [nzCurrent]="configStepIndex" nzDirection="vertical" nzSize="small">
        <nz-step nzTitle="Enable Your Microphone Permission" [nzDescription]="step1">
          <ng-template #step1>
            <div class="vertical-large step-content">
              <div class="horizontal">
                <div>Click "Allow" when the browser asks for your microphone permission.</div>
                <div>
                  <app-image-open-in-full
                    [width]="'170px'"
                    [src]="'/assets/images/setup-interview-assistant/step1_v1.png'"
                  ></app-image-open-in-full>
                </div>
              </div>
            </div>
          </ng-template>
        </nz-step>

        <nz-step nzTitle="Share Your Browser Tab" [nzDescription]="step2">
          <ng-template #step2>
            <div class="horizontal">
              <div class="vertical-large step-content">
                <div>
                  Select the specific browser tab you have opened with your interviewer and check "Also share tab
                  audio," then click "Share".
                </div>

                <button
                  class="fit-content"
                  nz-button
                  nzType="default"
                  nzSize="default"
                  (click)="onShareBrowserTabClick()"
                >
                  <span nz-icon style="font-size: 16px" class="material-icons-outlined">screen_share</span>
                  Share Broswer Tab
                </button>
              </div>

              <div>
                <app-image-open-in-full
                  [width]="'170px'"
                  [src]="'/assets/images/setup-interview-assistant/step2_v1.png'"
                ></app-image-open-in-full>
              </div>
            </div>
          </ng-template>
        </nz-step>

        <nz-step nzTitle="Select your Computer Audio" [nzDescription]="step3">
          <ng-template #step3>
            <div class="vertical-large step-content">
              <div>Select the microphone you're using during your interview.</div>

              <nz-select [(ngModel)]="selectedMicrophone">
                @for (item of microphoneList(); track $index) {
                  <nz-option [nzValue]="item" [nzLabel]="item.label"></nz-option>
                }
              </nz-select>
            </div>
          </ng-template>
        </nz-step>
      </nz-steps>
      <div class="horizontal" [ngStyle]="{ justifyContent: 'center' }">
        <button
          class="fit-content"
          nz-button
          nzType="primary"
          nzSize="large"
          [disabled]="isStartButtonDisabled()"
          (click)="onStartClick()"
        >
          <span nz-icon style="font-size: 16px" class="material-icons-outlined">rocket_launch</span>
          Start Interview
        </button>
      </div>
    </div>

    <img [ngStyle]="{ marginTop: '10px' }" width="130px" src="/assets/icons/logo-webapp.svg" alt="logo" />
  </div>
} @else {
  <div class="banner full-width">
    @if (isFreeTrialInterview && freeTrialMinsLeft() <= 3) {
      <nz-alert nzType="warning" [nzMessage]="freeTrialWarning()" nzShowIcon></nz-alert>
    }
    @if (!isDismiss && stopWorking) {
      <nz-alert
        nzType="error"
        nzMessage="Connection Issue"
        nzDescription="Oops, it seems you encountered a connection issue. You might want to reload the page to reconnect."
        nzShowIcon
        [nzAction]="actionStopWorking"
      ></nz-alert>

      <ng-template #actionStopWorking>
        <button nz-button [nzDanger]="true" nzType="primary" nzSize="large" (click)="onRefreshPageClick()">
          <span nz-icon style="font-size: 16px" class="material-icons-outlined">sync</span>
          Refresh Page
        </button>

        <button nz-button nzType="primary" nzSize="large" (click)="onDismissClick()">
          <span nz-icon style="font-size: 16px" class="material-icons-outlined">sync</span>
          Dismiss
        </button>
      </ng-template>
    }

    <ng-template #alertActionReconnect>
      <button nz-button nzType="default" nzSize="small" (click)="onMicReconnectClick()" [nzDanger]="true">
        <span nz-icon style="font-size: 16px" class="material-icons-outlined">sync</span>
        Reconnect
      </button>
    </ng-template>
    @if (micConnectStatus() === ConnectionStatus.loading) {
    } @else if (micConnectStatus() === ConnectionStatus.connected) {
    } @else if (
      (!isPause() && micConnectStatus() === ConnectionStatus.closed) || micConnectStatus() === ConnectionStatus.error
    ) {
      <nz-alert
        class="full-width"
        nzType="error"
        [nzMessage]="'Your mic has error. Please try to reconnect.'"
        nzShowIcon
        [nzAction]="alertActionReconnect"
      ></nz-alert>
    } @else if (micConnectStatus() === ConnectionStatus.warning) {
      <nz-alert
        class="full-width"
        nzType="warning"
        [nzMessage]="'Your mic has the warning message. Please try to reconnect.'"
        nzShowIcon
        [nzAction]="alertActionReconnect"
      ></nz-alert>
    }
  </div>

  <div class="vertical body full-height full-width">
    <div class="horizontal headings seperate">
      <div class="vertical">
        <div class="page-title horizontal-large">
          <div>
            <span>{{ goal?.subData?.position }} • </span>
            <span class="company">{{ goal?.subData?.company }}</span>
          </div>
        </div>
        <div class="horizontal-large">
          <div class="horizontal">
            <button
              nz-button
              nzType="default"
              nzSize="small"
              nz-popconfirm
              nzOkText="End"
              nzPopconfirmTitle="Are you sure you want to terminate the current interview?"
              nzPopconfirmPlacement="bottom"
              (nzOnConfirm)="onEndInterviewClick()"
            >
              <span nz-icon style="font-size: 16px" class="material-icons-outlined">power_settings_new</span>
              End Interview
            </button>

            @if (connectStatus() === ConnectionStatus.loading) {
              <nz-tag nzColor="processing" [matTooltip]="connectStatusReason">
                <span nz-icon nzType="sync" nzSpin></span>
                <span>connecting</span>
              </nz-tag>
            } @else if (connectStatus() === ConnectionStatus.connected && !isStoppedSharingTab()) {
              <nz-tag nzColor="success" [matTooltip]="connectStatusReason">
                <span nz-icon nzType="check-circle"></span>
                <span>Connected</span>
              </nz-tag>
            } @else if (isPause() && !isStoppedSharingTab()) {
              <nz-tag nzColor="default" [matTooltip]="'Paused'">
                <span nz-icon nzType="pause"></span>
                <span>Paused</span>
              </nz-tag>
            } @else if (
              connectStatus() === ConnectionStatus.closed ||
              connectStatus() === ConnectionStatus.error ||
              isStoppedSharingTab()
            ) {
              <nz-tag nzColor="error" [matTooltip]="connectStatusReason">
                <span nz-icon nzType="close-circle"></span>
                <span>Disconnected</span>
              </nz-tag>
              <button nz-button nzType="default" nzSize="small" [nzDanger]="true" (click)="onReconnectClick()">
                <span nz-icon style="font-size: 16px" class="material-icons-outlined">sync</span>
                Reconnect
              </button>
            } @else if (connectStatus() === ConnectionStatus.warning) {
              <nz-tag nzColor="warning" [matTooltip]="connectStatusReason">
                <span nz-icon nzType="exclamation-circle"></span>
                <span>{{ connectStatusReason }}</span>
              </nz-tag>
              <button nz-button nzType="default" nzSize="small" (click)="onReconnectClick()" [nzDanger]="true">
                <span nz-icon style="font-size: 16px" class="material-icons-outlined">sync</span>
                Reconnect
              </button>
            }
          </div>

          <div class="horizontal">
            <span>Pause</span>
            <div [ngStyle]="{ display: 'flex' }">
              <nz-switch [ngModel]="isPause()" (ngModelChange)="onPauseChange($event)" [nzSize]="'small'"></nz-switch>
              <app-question-button [text]="'Temporarily stops input and real-time support.'"></app-question-button>
            </div>
          </div>

          <div class="horizontal">
            <span>Auto Scroll</span>
            <div [ngStyle]="{ display: 'flex' }">
              <nz-switch [(ngModel)]="isAutoScroll" [nzSize]="'small'"></nz-switch>
              <app-question-button [text]="'Automatically scrolls to the latest updates.'"></app-question-button>
            </div>
          </div>

          <div class="timer horizontal" [matTooltip]="'Interview duration: ' + minsUsed() + ' minutes.'">
            <span nz-icon style="font-size: 14px" class="material-icons-outlined">timer</span>
            <div>{{ minsUsed() }} mins</div>
          </div>
        </div>
      </div>
      <div class="options vertical">
        @if (interview?.type === InterviewType.code) {
          <button class="fit-content" nz-button nzType="default" nzSize="default" (click)="getCodingAnswer()">
            <span nz-icon style="font-size: 16px" class="material-icons-outlined">code</span>
            <span>Get Coding Question from Tab</span>
          </button>
        }
        <div class="horizontal">
          <!-- <nz-segmented
            class="fit-content"
            [(ngModel)]="selectedPerformanceIndex"
            [nzOptions]="performanceOptions"
          ></nz-segmented> -->

          <nz-segmented
            class="fit-content"
            [nzSize]="'small'"
            [(ngModel)]="selectedCreativityIndex"
            [nzOptions]="creativityOptions"
          ></nz-segmented>

          <nz-segmented
            class="fit-content"
            [nzSize]="'small'"
            [(ngModel)]="selectedAnswerModeIndex"
            [nzOptions]="answerModeOptions"
          ></nz-segmented>
        </div>
      </div>
    </div>
    <div class="horizontal full-width chat-area">
      <div class="message-col interviewer full-height">
        <h3 class="horizontal seperate">
          <div>Interview Question</div>
          @if (streamStatus() === OpenAIStreamStatus.pending) {
            <nz-tag [nzColor]="'#7970c1'" [nzBordered]="false">
              <span>Listening...</span>
            </nz-tag>
          }
        </h3>
        <div class="message-list" #interviewer>
          @for (item of interviewerList(); track i; let i = $index) {
            <div
              class="message-block"
              [ngClass]="i === selectedIndex ? ['hover'] : []"
              (mouseover)="onInterviewerMessageMouseover(i)"
            >
              {{ item }}
            </div>
          }
        </div>
      </div>
      <div class="message-col copilot full-height">
        <h3 class="horizontal copilot-title seperate">
          <div>Suggested Answer</div>
          @if (streamStatus() === OpenAIStreamStatus.generating) {
            <nz-tag [nzColor]="'#6252df'" [nzBordered]="false">
              <span>Generating...</span>
            </nz-tag>
          } @else if (streamStatus() === OpenAIStreamStatus.failed) {
            <nz-tag nzColor="error" [nzBordered]="false">
              <span nz-icon nzType="close-circle"></span>
              <span>Failed</span>
            </nz-tag>
          } @else if (analyzingImage()) {
            <nz-tag [nzColor]="'#6252df'" [nzBordered]="false">
              <span>Analyzing...</span>
            </nz-tag>
          }
        </h3>
        @if (interview?.type === InterviewType.code) {
          <nz-tabset [nzTabPosition]="'bottom'" [(nzSelectedIndex)]="codeTabIndex">
            <nz-tab [nzTitle]="chatTitle()">
              <div class="message-list" #aiResponse>
                @for (item of aiResponseList(); track i; let i = $index) {
                  <div
                    class="message-block"
                    [ngClass]="i === selectedIndex ? ['hover'] : []"
                    (mouseover)="onAiResponseMessageMouseover(i)"
                  >
                    <div [innerHTML]="item | markdownIt"></div>
                  </div>
                }
              </div>
            </nz-tab>
            @for (tab of codingTabs; track i; let i = $index) {
              <nz-tab [nzTitle]="tab">
                @if (tab === CodingResponseType.idea) {
                  <div class="message-list" #ideaResponse>
                    @for (item of codeIdeaList(); track i; let i = $index) {
                      <div class="message-block">
                        <div [innerHTML]="item | markdownIt"></div>
                      </div>
                    }
                  </div>
                } @else if (tab === CodingResponseType.code) {
                  <div class="message-list" #codeResponse>
                    @for (item of codeSolutionList(); track i; let i = $index) {
                      <div class="message-block">
                        <div [innerHTML]="item | markdownIt"></div>
                      </div>
                    }
                  </div>
                } @else if (tab === CodingResponseType.testCases) {
                  <div class="message-list" #testCases>
                    @for (item of codeTestCasesList(); track i; let i = $index) {
                      <div class="message-block">
                        <div [innerHTML]="item | markdownIt"></div>
                      </div>
                    }
                  </div>
                }
              </nz-tab>
            }
          </nz-tabset>
        } @else {
          <div class="message-list" #aiResponse>
            @for (item of aiResponseList(); track i; let i = $index) {
              <div
                class="message-block"
                [ngClass]="i === selectedIndex ? ['hover'] : []"
                (mouseover)="onAiResponseMessageMouseover(i)"
              >
                <div [innerHTML]="item | markdownIt"></div>
                @if (streamStatus() === OpenAIStreamStatus.pending && aiResponseList().length - 2 === i) {
                  <div class="buttons horizontal">
                    <button
                      nz-button
                      nzType="default"
                      nzSize="small"
                      (click)="onRerunClick(InterviewPerformance.Quality)"
                    >
                      <span nz-icon style="font-size: 16px" class="material-icons-outlined">autorenew</span>
                      Regenerate
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <div class="message-col my-talking full-height">
        <h3>My Answer</h3>
        <div class="message-list" #myAnswer>
          @for (item of myAnswerList(); track i; let i = $index) {
            <div
              class="message-block"
              [ngClass]="i === selectedIndex ? ['hover'] : []"
              (mouseover)="onMyAnswerMessageMouseover(i)"
            >
              {{ item }}
            </div>
          }
        </div>
      </div>
    </div>

    <img
      [ngStyle]="{ marginTop: '5px', marginBottom: '10px' }"
      width="120px"
      src="/assets/icons/logo-webapp.svg"
      alt="logo"
    />
  </div>
}

<nz-modal
  [(nzVisible)]="isNeedToShareAudioModalVisible"
  nzTitle="Please share your tab with audio."
  [nzCancelDisabled]="true"
  [nzOkText]="'Refresh Page.'"
  (nzOnOk)="handleNeedToShareAudioModalOk()"
>
  <ng-container *nzModalContent>
    <p>Please share your tab with audio. Refresh the page to try again.</p>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isNeedGoalVisible"
  nzTitle="Cannot find your goal."
  [nzMaskClosable]="false"
  [nzCancelDisabled]="true"
  [nzCancelText]="null"
  [nzOkText]="'Refresh Page.'"
  (nzOnOk)="refreshPage()"
>
  <ng-container *nzModalContent>
    <p>Cannot find your goal. Please refresh the page to try again.</p>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isNeedResumeVisible"
  nzTitle="Cannot find your resume."
  [nzMaskClosable]="false"
  [nzCancelDisabled]="true"
  [nzCancelText]="null"
  [nzOkText]="'Refresh Page.'"
  (nzOnOk)="refreshPage()"
>
  <ng-container *nzModalContent>
    <p>Cannot find your resume. Please refresh the page to try again.</p>
  </ng-container>
</nz-modal>

<app-interview-survey
  [(isVisible)]="isEndSurveyVisible"
  (isVisibleChange)="onEndInterviewSurveyVisibleChange($event)"
></app-interview-survey>

<app-text-image-modal
  [isVisible]="showInterviewEndModal()"
  title="Interview Ended"
  content="Your current interview has ended. You can start a new interview if needed."
  imageSrc="/assets/images/vector-illustrations/interview-complete.png"
  okText="End Interview"
  (okClick)="onEndInterviewClick()"
  [cancelText]="undefined"
  [closable]="false"
></app-text-image-modal>
